import { useQuery } from '@tanstack/react-query';

import type { CommonData } from '@models/commonData';

import { getCommonData } from './api';

export function useCommonDataQuery() {
  return useQuery<CommonData>({
    queryKey: ['commonData'],
    queryFn: getCommonData,
  });
}
